import { render, staticRenderFns } from "./ManageUserGroups.vue?vue&type=template&id=038c0454&"
import script from "./ManageUserGroups.vue?vue&type=script&lang=js&"
export * from "./ManageUserGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports